import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  FormControlLabel,
  Grid,
  Switch,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import { useMaterialUIController } from "context";
import { useEffect, useState } from "react";
import getText from "Translator";
// import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import MoreVertIcon from "@mui/icons-material/MoreVert";

let clearError = false;

export default function DBComponent(props) {
  const [error, setError] = useState(false);
  const { question, disabled, editQuestionHandle, helpPage, headline } = props;
  const [controller, dispatch] = useMaterialUIController();
  const [expanded, setExpanded] = useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  useEffect(() => {
    addItems();
  }, []);
  const addItems = () => {
    console.log("question.answersquestion.answers", question.answers);
    try {
      let newAnswersItems = [];
      let op = "";
      if (question.answers[0].titleOption1 !== "") {
        op = question.answers[0].titleOption1;
      }
      newAnswersItems.push({
        title: op,
        answers: [],
      });
      question.answers.map((ans, ind) => {
        if (
          op == ans.titleOption1 ||
          ans.titleOption1 == "" ||
          ans.titleOption1 + "" == "null"
        ) {
          newAnswersItems[newAnswersItems.length - 1].answers.push(ans);
        }
        if (
          op !== ans.titleOption1 &&
          ans.titleOption1 !== "" &&
          ans.titleOption1 + "" !== "null"
        ) {
          op = ans.titleOption1;

          newAnswersItems.push({
            title: op,
            uanswers: "",
            answers: [ans],
          });
        }
      });
      let items = [];
      newAnswersItems.map((item, index) => {
        let uanss = "";
        item.answers.map((uans) => {
          if (question.useranswer.includes(uans.id)) {
            uanss += uans.answer + " , ";
          }
        });
        item.uanswers = uanss;
      });
      newAnswersItems.map((item, index) =>
        items.push(
          <Accordion
            key={index + "_cccmdb"}
            style={{ backgroundColor: "TRANSPARENT", borderRadius: 7 }}
            expanded={expanded === "panel" + index}
            onChange={handleChange("panel" + index)}
          >
            {item.title !== "" && (
              <AccordionSummary
                style={{ backgroundColor: "#f0f0f0", borderRadius: 7 }}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <div>
                  <b>{item.title}</b>
                  <br />
                  <p style={{ fontSize: 13, marginTop: -5 }}>
                    {item.uanswers
                      ? item.uanswers.substring(0, item.uanswers.length - 2)
                      : ""}
                  </p>
                </div>
              </AccordionSummary>
            )}
            <AccordionDetails>
              <Grid container>{renderAccordionDetails(item.answers)}</Grid>
            </AccordionDetails>
          </Accordion>
        )
      );

      return items;
    } catch (err) {
      console.log(err);
      return <></>;
    }
  };
  const renderAccordionDetails = (newAnswers) => {
    try {
      let items = [];
      newAnswers.map((ans, index) => {
        items.push(
          <>
            <Grid
              xs={question.answerSize ? question.answerSize : 12}
              sm={question.answerSize ? question.answerSize : 12}
              md={question.answerSize ? question.answerSize : 12}
            >
              <FormControlLabel
                disabled={disabled}
                key={"FormControlLabel_MDBComponent_" + ans.id}
                style={{
                  width: "100%",
                  flex: 1,
                  marginTop: 0,
                  marginBottom: -3,
                  display: "flex",
                }}
                control={
                  <>
                    <Switch
                      color="secondary"
                      key={ans.id + index + ""}
                      checked={
                        question.useranswer + "" === ans.id + "" ? true : false
                      }
                      onClick={async () => {
                        if (ans.help) {
                          await editQuestionHandle(question, ans.id, true);
                          helpPage(ans.help);
                        }
                      }}
                      onChange={async () => {
                        if (question.useranswer + "" !== ans.id + "") {
                          await editQuestionHandle(question, ans.id);

                          let chc =
                            question.useranswer + "" === ans.id + ""
                              ? false
                              : true;

                          if (ans.help) {
                            // helpPage(ans.help);
                          } else {
                            if (ans.isNext && headline !== "scores") {
                              dispatch({
                                type: "action",
                                payload: { action: "nextpage" + new Date() },
                              });
                            }
                            if (ans.isBack && headline !== "scores") {
                              dispatch({
                                type: "action",
                                payload: { action: "backpage" + new Date() },
                              });
                            }
                          }
                        }
                      }}
                      name={ans.answer}
                    />
                    {ans.help && (
                      <MoreVertIcon
                        style={{
                          position: "absolute",
                          color: "rgb(189, 73, 65)",
                          width: 15,
                          height: 15,
                          right: 0,
                          top: 1,
                        }}
                      />
                    )}
                  </>
                }
                label={ans.answer}
              />
            </Grid>
            {ans.titleOption2 !== "" && ans.titleOption2 + "" !== "null" && (
              <Grid xs={12} sm={12} md={12}>
                <b>{ans.titleOption2}</b>
              </Grid>
            )}
          </>
        );
      });
      return items;
    } catch (err) {
      console.log(err);
      return <></>;
    }
  };
  return (
    <Grid
      item
      key={question.questionCode + ""}
      xs={12}
      sm={12}
      md={12}
      style={{
        marginTop: question.titleType === 2 ? 8 : question.displayTitle ? 5 : 8,

        marginBottom: question.helpPage ? -15 : 0,
        display: question.visible ? "" : "none",
        //backgroundColor: index % 2 == 0 ? "TRANSPARENT" : "#ebdfe2",
      }}
    >
      {question.displayTitle && <b>{question.text + "---"}</b>}

      {question.allowCopy && question.copyValue && (
        <ContentCopyIcon
          onClick={async () => {
            if (question.useranswer == question.copyValue) {
              await editQuestionHandle(question, "");
            } else {
              await editQuestionHandle(question, question.copyValue);
            }
          }}
          style={{
            color: "#039dfc",
            height: 20,
            width: 25,
            position: "relative",
            right: "fa" == "en" ? 0 : "none",
            left: "fa" == "fa" ? 0 : "none",
            top: 15,
            float: "fa" == "en" ? "right" : "left",
            cursor: "pointer",
            zIndex: 999,
          }}
        />
      )}
      {/* <div
    style={{
      border: "1px solid #039dfc",
      borderRadius: 3,
      flexDirection: "column",
      padding: 8,
    }}
  > */}
      <fieldset
        style={{
          borderColor: "#039dfc",
          color: "#039dfc",
          borderWidth: "thin",
          flexDirection: "column",
          padding: 15,
          borderRadius: 7,
        }}
        className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
      >
        {addItems()}
      </fieldset>
      {/* </div> */}
      {question.helpPage && (
        <Button
          style={{
            marginTop: -10,
          }}
          onClick={() => {
            helpPage(question.helpPage);
          }}
          className="helplink"
          fullWidth={true}
        >
          <div
            style={{
              width: "100%",
              fontSize: 11,
              textAlign: "fa" == "fa" ? "left" : "right",
            }}
          >
            {question.helpText === ""
              ? getText("helptext", "fa")
              : question.helpText}
          </div>
        </Button>
      )}
    </Grid>
  );
}
